var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"server-error"},[_c('ico',{attrs:{"name":"icoErrorOutline","color":"#F84242"}}),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }